import React from "react";
import SpecialLifeAtButton from "@common/LifeAtButton/Variants/SpecialLifeAtButton";
import LifeAtModal from "@common/LifeAtModal/LifeAtModal";
import useQueryParam from "@hooks/useQueryParam";

const PAGE_TITLE = "Are you sure you want to leave LifeAt?";
const PAGE_SUBTITLE = "This link is taking you to a site outside LifeAt";
const BUTTON_LABEL = "Follow link";

export default function ExternalRedirectPage() {
    const query = useQueryParam();
    const externalLink = query.get("url");
    const externalHost = new URL(externalLink).host;

    return (
        <LifeAtModal
            title={PAGE_TITLE}
            subtitle={buildSubtitle(externalHost)}
            isOpen
            closeModal={() => {}}
            preventClose
            centerContent
        >
            <SpecialLifeAtButton isLink link={externalLink} openInCurrTab text={BUTTON_LABEL} variant="blue" />
        </LifeAtModal>
    );
}

function buildSubtitle(externalHost: string) {
    return PAGE_SUBTITLE + " (" + externalHost + ").";
}
